import { render } from "./ServiceMultiSelect.vue?vue&type=template&id=5789a644&scoped=true"
import script from "./ServiceMultiSelect.vue?vue&type=script&lang=js"
export * from "./ServiceMultiSelect.vue?vue&type=script&lang=js"

import "./ServiceMultiSelect.vue?vue&type=style&index=0&id=5789a644&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5789a644"]])

export default __exports__